import React, { Component } from "react";

class PanelHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const { className, children } = this.props;

		const style = ["panel-header-component", className].join(" ");

		return <div className={style}>{children}</div>;
	}
}

export default PanelHeader;
